import React, { useEffect, useState } from 'react';
import {Statistic, Card, Row, Col, Spin} from 'antd';
import axios from 'axios';
import PageTitle from "../../components/PageTitle";

const Statistics = ({backendApiUrl}) => {
    const [trucks, setTrucks] = useState([]);
    const [trailers, setTrailers] = useState([]);
    const [vans, setVans] = useState([]);
    const [cars, setCars] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const [trucksRes, trailersRes, vansRes, carsRes] = await Promise.all([
                    axios.get(`${backendApiUrl}/trucks/`),
                    axios.get(`${backendApiUrl}/trailers/`),
                    axios.get(`${backendApiUrl}/vans/`),
                    axios.get(`${backendApiUrl}/cars/`)
                ]);
                setTrucks(trucksRes.data);
                setTrailers(trailersRes.data);
                setVans(vansRes.data);
                setCars(carsRes.data);
            } catch (error) {
                console.error("Erreur lors du chargement des données :", error);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [backendApiUrl]);

    const totalTrucks = trucks.length;
    const totalMileage = trucks.reduce((sum, t) => sum + (t.miles || 0), 0);
    const totalKilometersPerTruck = totalTrucks ? (totalMileage / totalTrucks).toFixed(0) : 0;
    const availableCount = trucks.filter(t =>
        t.availability?.status === 'Disponible' &&
        t.availability?.details !== 'Maintenance programmée' &&
        t.availability?.details !== 'Contre-visite'
    ).length;
    const maintenanceCount = trucks.filter(t => t.availability?.status === 'En maintenance').length;
    const outOfServiceCount = trucks.filter(t => t.availability?.status === 'Hors service').length;
    const avgInsideStatus = totalTrucks ? (trucks.reduce((sum, t) => sum + t.insideStatus, 0) / totalTrucks).toFixed(1) : 0;
    const avgOutsideStatus = totalTrucks ? (trucks.reduce((sum, t) => sum + t.outsideStatus, 0) / totalTrucks).toFixed(1) : 0;
    const trucksWithTailgates = trucks.filter(t => t.hasTailgates).length;
    const trucksWithTranspal = trucks.filter(t => t.transpal).length;
    const trucksMissingLogos = trucks.filter(t => t.logosOK === false).length;
    const anglesMortsNotOK = trucks.filter(t => t.anglesMortsOK === false).length;


    const totalTrailers = trailers.length;
    const availableCountT = trailers.filter(t =>
        t.availability?.status === 'Disponible' &&
        t.availability?.details !== 'Maintenance programmée' &&
        t.availability?.details !== 'Contre-visite'
    ).length;
    const maintenanceCountT = trailers.filter(t => t.availability?.status === 'En maintenance').length;
    const outOfServiceCountT = trailers.filter(t => t.availability?.status === 'Hors service').length;
    const avgInsideStatusT = totalTrailers ? (trailers.reduce((sum, t) => sum + t.insideStatus, 0) / totalTrailers).toFixed(1) : 0;
    const avgOutsideStatusT = totalTrailers ? (trailers.reduce((sum, t) => sum + t.outsideStatus, 0) / totalTrailers).toFixed(1) : 0;
    const tailersWithTailgates = trailers.filter(t => t.hasTailgates).length;
    const trailersWithTranspal = trailers.filter(t => t.transpal).length;


    const totalVans = vans.length;
    const availableCountV = vans.filter(t =>
        t.availability?.status === 'Disponible' &&
        t.availability?.details !== 'Maintenance programmée' &&
        t.availability?.details !== 'Contre-visite'
    ).length;
    const maintenanceCountV = vans.filter(t => t.availability?.status === 'En maintenance').length;
    const outOfServiceCountV = vans.filter(t => t.availability?.status === 'Hors service').length;
    const avgInsideStatusV = totalVans ? (vans.reduce((sum, t) => sum + t.insideStatus, 0) / totalVans).toFixed(1) : 0;
    const avgOutsideStatusV = totalVans ? (vans.reduce((sum, t) => sum + t.outsideStatus, 0) / totalVans).toFixed(1) : 0;


    const totalCars = cars.length;
    const availableCountC = cars.filter(t =>
        t.availability?.status === 'Disponible' &&
        t.availability?.details !== 'Maintenance programmée' &&
        t.availability?.details !== 'Contre-visite'
    ).length;
    const maintenanceCountC = cars.filter(t => t.availability?.status === 'En maintenance').length;
    const outOfServiceCountC = cars.filter(t => t.availability?.status === 'Hors service').length;
    const avgInsideStatusC = totalCars ? (cars.reduce((sum, t) => sum + t.insideStatus, 0) / totalCars).toFixed(1) : 0;
    const avgOutsideStatusC = totalCars ? (cars.reduce((sum, t) => sum + t.outsideStatus, 0) / totalCars).toFixed(1) : 0;

    return (
        <div className={"mb-auto"}>
            <div style={{ marginBottom: "30px", width: "100%" }}>
                <div className={"w-100 flex justify-between gap-2 flex-wrap"}>
                    <div className={"flex gap-5 flex-wrap flex-center"}>
                        <PageTitle title={"Statistiques"}></PageTitle>
                    </div>
                </div>
                <div className={"w-100 flex justify-between gap-2 flex-wrap mt-5"}>
                    <p className={"text-xl ml-3 mb-1"} style={{fontWeight: "700"}}>Camions</p>
                    <Row gutter={[16, 16]} style={{ width: "100%"}}>
                        <Col xs={24} sm={12} md={8} lg={8}><Card><Statistic title="Total camions" value={totalTrucks} valueStyle={{ fontSize: '26px', color: '#1890ff' }} /></Card></Col>
                        <Col xs={24} sm={12} md={8} lg={8}><Card><Statistic title="Kilométrage total" value={totalMileage.toLocaleString()} suffix="km" valueStyle={{ fontSize: '26px', color: '#1890ff' }} /></Card></Col>
                        <Col xs={24} sm={12} md={8} lg={8}><Card><Statistic title="Kilométrage moyen / camion" value={totalKilometersPerTruck} suffix="km" valueStyle={{ fontSize: '26px', color: '#1890ff' }} /></Card></Col>
                        <Col xs={24} sm={12} md={8} lg={6}>
                            <Card>
                                <Statistic
                                    title="Disponibles"
                                    value={availableCount}
                                    valueStyle={{ color: 'green' }}
                                />
                            </Card>
                        </Col>
                        <Col xs={24} sm={12} md={8} lg={6}>
                            <Card>
                                <Statistic
                                    title="En maintenance"
                                    value={maintenanceCount}
                                    valueStyle={{ color: 'orange' }}
                                />
                            </Card>
                        </Col>
                        <Col xs={24} sm={12} md={8} lg={6}>
                            <Card>
                                <Statistic
                                    title="Hors service"
                                    value={outOfServiceCount}
                                    valueStyle={{ color: '#cf1322' }}
                                />
                            </Card>
                        </Col>
                        <Col xs={24} sm={12} md={8} lg={6}><Card><Statistic title="Logos manquants" value={trucksMissingLogos} valueStyle={{ fontSize: '26px', color: '#cf1322' }}/></Card></Col>
                        <Col xs={24} sm={12} md={8} lg={6}><Card><Statistic title="Angles morts non OK" value={anglesMortsNotOK} valueStyle={{ fontSize: '26px', color: '#cf1322' }}/></Card></Col>

                        <Col xs={24} sm={12} md={8} lg={6}><Card><Statistic title="État intérieur moyen" value={avgInsideStatus} suffix="/10" /></Card></Col>
                        <Col xs={24} sm={12} md={8} lg={6}><Card><Statistic title="État extérieur moyen" value={avgOutsideStatus} suffix="/10" /></Card></Col>
                        <Col xs={24} sm={12} md={8} lg={6}><Card><Statistic title="Avec hayon" value={trucksWithTailgates} /></Card></Col>
                        <Col xs={24} sm={12} md={8} lg={6}><Card><Statistic title="Avec transpalette" value={trucksWithTranspal} /></Card></Col>
                    </Row>
                </div>
                <div className={"w-100 flex justify-between gap-2 flex-wrap mt-8"}>
                    <p className={"text-xl ml-3 mb-1"} style={{fontWeight: "700"}}>Remorques</p>
                    <Row gutter={[16, 16]} style={{ width: "100%"}}>
                        <Col xs={24} sm={12} md={8} lg={6}><Card><Statistic title="Total remorques" value={totalTrailers} valueStyle={{ fontSize: '26px', color: '#1890ff' }} /></Card></Col>
                        <Col xs={24} sm={12} md={8} lg={6}><Card><Statistic title="Disponibles" value={availableCountT} valueStyle={{ color: 'green' }}/></Card></Col>
                        <Col xs={24} sm={12} md={8} lg={6}><Card><Statistic title="En maintenance" value={maintenanceCountT} valueStyle={{ color: 'orange' }}/></Card></Col>
                        <Col xs={24} sm={12} md={8} lg={6}><Card><Statistic title="Hors service" value={outOfServiceCountT} valueStyle={{ color: '#cf1322' }}/></Card></Col>

                        <Col xs={24} sm={12} md={8} lg={6}><Card><Statistic title="État intérieur moyen" value={avgInsideStatusT} suffix="/10" /></Card></Col>
                        <Col xs={24} sm={12} md={8} lg={6}><Card><Statistic title="État extérieur moyen" value={avgOutsideStatusT} suffix="/10" /></Card></Col>

                        <Col xs={24} sm={12} md={8} lg={6}><Card><Statistic title="Avec hayon" value={tailersWithTailgates} /></Card></Col>
                        <Col xs={24} sm={12} md={8} lg={6}><Card><Statistic title="Avec transpalette" value={trailersWithTranspal} /></Card></Col>
                    </Row>
                </div>
                <div className={"w-100 flex justify-between gap-2 flex-wrap mt-8"}>
                    <p className={"text-xl ml-3 mb-1"} style={{fontWeight: "700"}}>Camionettes</p>
                    <Row gutter={[16, 16]} style={{ width: "100%"}}>
                        <Col xs={24} sm={12} md={8} lg={6}><Card><Statistic title="Total camionettes" value={totalVans} valueStyle={{ fontSize: '26px', color: '#1890ff' }} /></Card></Col>
                        <Col xs={24} sm={12} md={8} lg={6}><Card><Statistic title="Disponibles" value={availableCountV} valueStyle={{ color: 'green' }}/></Card></Col>
                        <Col xs={24} sm={12} md={8} lg={6}><Card><Statistic title="En maintenance" value={maintenanceCountV} valueStyle={{ color: 'orange' }}/></Card></Col>
                        <Col xs={24} sm={12} md={8} lg={6}><Card><Statistic title="Hors service" value={outOfServiceCountV} valueStyle={{ color: '#cf1322' }}/></Card></Col>
                        <Col xs={24} sm={12} md={8} lg={6}><Card><Statistic title="État intérieur moyen" value={avgInsideStatusV} suffix="/10" /></Card></Col>
                        <Col xs={24} sm={12} md={8} lg={6}><Card><Statistic title="État extérieur moyen" value={avgOutsideStatusV} suffix="/10" /></Card></Col>
                    </Row>
                </div>
                <div className={"w-100 flex justify-between gap-2 flex-wrap mt-8"}>
                    <p className={"text-xl ml-3 mb-1"} style={{fontWeight: "700"}}>Voitures</p>
                    <Row gutter={[16, 16]} style={{ width: "100%"}}>
                        <Col xs={24} sm={12} md={8} lg={6}><Card><Statistic title="Total voitures" value={totalCars} valueStyle={{ fontSize: '26px', color: '#1890ff' }}/></Card></Col>
                        <Col xs={24} sm={12} md={8} lg={6}><Card><Statistic title="Disponibles" value={availableCountC} valueStyle={{ color: 'green' }}/></Card></Col>
                        <Col xs={24} sm={12} md={8} lg={6}><Card><Statistic title="En maintenance" value={maintenanceCountC} valueStyle={{ color: 'orange' }}/></Card></Col>
                        <Col xs={24} sm={12} md={8} lg={6}><Card><Statistic title="Hors service" value={outOfServiceCountC} valueStyle={{ color: '#cf1322' }}/></Card></Col>
                        <Col xs={24} sm={12} md={8} lg={6}><Card><Statistic title="État intérieur moyen" value={avgInsideStatusC} suffix="/10" /></Card></Col>
                        <Col xs={24} sm={12} md={8} lg={6}><Card><Statistic title="État extérieur moyen" value={avgOutsideStatusC} suffix="/10" /></Card></Col>
                    </Row>
                </div>
            </div>
        </div>
    );
};

export default Statistics;